/**
 * Compact column definitions for the Users table.
 * Merged firstName+lastName into "User" column, dates simplified,
 * actions use dropdown instead of 4 inline buttons.
 */
const columns = () => ([
  {
    title: 'User',
    key: 'user',
    width: '25%',
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
    width: '10%',
  },
  {
    title: 'Company',
    dataIndex: 'companyId',
    key: 'companyId',
    width: '14%',
  },
  {
    title: 'Registered',
    dataIndex: 'addedAt',
    key: 'addedAt',
    width: '12%',
  },
  {
    title: 'Status',
    dataIndex: 'isDeleted',
    key: 'isDeleted',
    width: '8%',
  },
  {
    title: '',
    key: 'actions',
    width: '5%',
    align: 'center',
  },
]);

export default columns;
